import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProgramService } from '../../../services/vpp/program.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Program } from '../../../domain/cloud-topology';
import { ToastService } from '../../../services/toast-service';

@Component({
    selector: 'app-program-view',
    templateUrl: './program-view.component.html',
    standalone: false
})
export class ProgramViewComponent implements OnInit, OnDestroy {

  private programId: string;
  private subject$: Subject<void>;
  program: Program;

  constructor(private route: ActivatedRoute,
              private programService: ProgramService,
              private toastService: ToastService) { }

  ngOnInit() {
    this.subject$ = new Subject<void>();
    this.route.paramMap.subscribe(paramMap => {
      this.programId = paramMap.get('id');
      this.programService.getProgram(this.programId).pipe(takeUntil(this.subject$)).subscribe(programData => {
        this.program = programData;
      }, () => {
        this.toastService.show('There was a problem retrieving the program.', {
          classname: 'bg-danger text-light',
          delay: 5000
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.subject$.next();
  }
}
